import { useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    MenuItem,
    useMediaQuery,
    ToggleButtonGroup,
    ToggleButton,
    InputAdornment,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../components/Header";
import ModalCharge from "../../modal/modalCharge";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalEmpresas from "../../modal/empresas/modalEmpresas";
import { PostUniformes } from "../../services/uniformes.services";
import { getApiBaseUrl } from "../../utils/getApiBaseUrl";
import { getUniformes } from "../../services/uniformes.services";
import { useEffect } from "react";

const RegistroUniforme = () => {
    const [isLoading, setIsLoading] = useState(false);
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const [registrationSuccess, setRegistrationSuccess] = useState(false);
    const [registrationError, setRegistrationError] = useState(false);
    const [error, setError] = useState("");

    // Para el modal de empresas
    const [openModalEmpresas, setOpenModalEmpresas] = useState(false);
    const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);

    // Para las opciones del autocomplete de descripcion y talla
    const [opcionesDescripcion, setOpcionesDescripcion] = useState([]);
    const [opcionesTalla, setOpcionesTalla] = useState([]);
    const [tipoTalla, setTipoTalla] = useState("letra"); // "letra" o "numero"

    // Para preview de imagen
    const [imagenPreview, setImagenPreview] = useState(null);

    // Controles de UI para los selects custom
    const [descripcionInput, setDescripcionInput] = useState("");
    const [tallaInput, setTallaInput] = useState("");
    const [showDescripcionOpciones, setShowDescripcionOpciones] = useState(false);
    const [showTallaOpciones, setShowTallaOpciones] = useState(false);
    const [fileInputKey, setFileInputKey] = useState(Date.now());

    useEffect(() => {
        const cargarOpciones = async () => {
            try {
                const data = await getUniformes(); // trae todos los uniformes existentes
            
                // Extraer descripciones únicas
                const descripciones = [...new Set(data.map((u) => u.descripcion))];
                setOpcionesDescripcion(descripciones);

                // Extraer tallas únicas
                const tallas = [...new Set(data.map((u) => u.talla))];
                setOpcionesTalla(tallas);
            } catch (error) {
                console.error("Error al cargar opciones:", error);
            }
        };

        cargarOpciones();
    }, []);

        const handleSubmit = async (values, { resetForm }) => {
            setIsLoading(true);

            try {
                const dataToSend = {
                    descripcion: values.descripcion,
                    talla: values.talla,
                    img: values.img,
                    cod_empresa: values.cod_empresa,
                };       
                const response = await PostUniformes(dataToSend);
            
                setRegistrationSuccess(true);
                resetForm();
                setEmpresaSeleccionada(null);
                setImagenPreview(null);
                setDescripcionInput("");
                setTallaInput("");
                setFileInputKey(Date.now());
            }   catch (error) {
                console.error(error);
                setRegistrationError(true);
                setError(error.message);
            }   finally {
                setTimeout(() => {
                    setIsLoading(false);
                }, 1000);
            }
        };

        const handleFileUpload = async (file, setFieldValue) => {
            try {
              // Preview local inmediato
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImagenPreview(reader.result);
                };
                reader.readAsDataURL(file);
            
                const formData = new FormData();
                formData.append("image", file);
            
                const response = await fetch(`${getApiBaseUrl()}upload`, {
                    method: "POST",
                    body: formData,
                });
            
                if (response.ok) {
                    const data = await response.json();
                    setFieldValue("img", data.filePath);
                } else {
                    console.error("Error al subir imagen");
                }
            } catch (error) {
                console.error("Error upload:", error);
            }
        };

        // Filtra las opciones de descripcion segun lo que escribe el usuario
        const descripcionesFiltradas = opcionesDescripcion.filter((op) =>
            op.toLowerCase().includes(descripcionInput.toLowerCase()),
        );

        // Filtra las opciones de talla segun lo que escribe el usuario
        // y segun el tipo elegido (letra o numero)
        const tallasFiltradas = opcionesTalla.filter((t) => {
            const matchTexto = t.toLowerCase().includes(tallaInput.toLowerCase());
            const esNumero = !isNaN(t);
            if (tipoTalla === "numero") return matchTexto && esNumero;
            if (tipoTalla === "letra") return matchTexto && !esNumero;
            return matchTexto;
        });

        return (
        <Box m="20px">
            <Header
                title="Registro de Uniformes"
                subtitle="Registrar uniformes por empresa"
            />

            <ModalCharge isLoading={isLoading} />
            <ModalSucces
                open={registrationSuccess}
                onClose={() => setRegistrationSuccess(false)}
            />
            <ModalError
                open={registrationError}
                onClose={() => setRegistrationError(false)}
                error={error}
            />

            <Formik
                initialValues={{
                descripcion: "",
                talla: "",
                img: "",
                cod_empresa: "",
                }}
                validationSchema={checkoutSchema}
                onSubmit={handleSubmit}
                validateOnChange={false}
                validateOnBlur={false}
            >
                {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                }) => (
                <form onSubmit={handleSubmit}>
                    <ModalEmpresas
                    open={openModalEmpresas}
                    onClose={() => setOpenModalEmpresas(false)}
                    onSelectEmpresa={(empresa) => {
                        setEmpresaSeleccionada(empresa);
                        setFieldValue("cod_empresa", empresa.id);
                        setOpenModalEmpresas(false);
                    }}
                    />
                    <Box
                    display="grid"
                    gap="20px"
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    >
                    {/* INPUT DESCRIPCION     */}
                    <Box sx={{ gridColumn: "span 2", position: "relative" }}>
                        <TextField
                        variant="filled"
                        label="Descripción"
                        name="descripcion"
                        value={descripcionInput}
                        onChange={(e) => {
                            setDescripcionInput(e.target.value);
                            setFieldValue("descripcion", e.target.value);
                            setShowDescripcionOpciones(true);
                        }}
                        onBlur={() => {
                            // delay para que el click en la opcion tenga tiempo de ejecutarse
                            setTimeout(() => setShowDescripcionOpciones(false), 150);
                        }}
                        onFocus={() => setShowDescripcionOpciones(true)}
                        error={!!touched.descripcion && !!errors.descripcion}
                        helperText={touched.descripcion && errors.descripcion}
                        fullWidth
                        />
                        {/* Dropdown custom de opciones */}
                        {showDescripcionOpciones &&
                        descripcionesFiltradas.length > 0 && (
                            <Box
                            sx={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                zIndex: 9999,
                                backgroundColor: "rgb(30,30,30)",
                                border: "1px solid rgba(255,255,255,0.15)",
                                borderRadius: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                            }}
                            >
                            {descripcionesFiltradas.map((opcion, index) => (
                                <Box
                                key={index}
                                onMouseDown={() => {
                                    setDescripcionInput(opcion);
                                    setFieldValue("descripcion", opcion);
                                    setShowDescripcionOpciones(false);
                                }}
                                sx={{
                                    padding: "10px 16px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    "&:hover": {
                                    backgroundColor: "rgba(206, 220, 0, 0.15)",
                                    },
                                }}
                                >
                                {opcion}
                                </Box>
                            ))}
                            </Box>
                        )}
                    </Box>

                    {/* ===================== */}
                    {/* INPUT TALLA           */}
                    {/* Toggle + Select       */}
                    {/* ===================== */}
                    {/* ===================== */}
                    <Box sx={{ gridColumn: "span 2" }}>
                        {/* Toggle letra / numero */}

                        {/* INPUT TALLA con toggle integrado */}
                        <Box sx={{ gridColumn: "span 2", position: "relative" }}>
                        <TextField
                            variant="filled"
                            label={
                            tipoTalla === "numero"
                                ? "Talla (número)"
                                : "Talla (letra)"
                            }
                            name="talla"
                            value={tallaInput}
                            onChange={(e) => {
                            const val = e.target.value;
                            if (tipoTalla === "numero" && val !== "" && isNaN(val))
                                return;
                            setTallaInput(val);
                            setFieldValue("talla", val);
                            setShowTallaOpciones(true);
                            }}
                            onBlur={() => {
                            setTimeout(() => setShowTallaOpciones(false), 150);
                            }}
                            onFocus={() => setShowTallaOpciones(true)}
                            error={!!touched.talla && !!errors.talla}
                            helperText={touched.talla && errors.talla}
                            fullWidth
                            InputProps={{
                            // ✅ Toggle integrado como adorno al final del input
                            endAdornment: (
                                <InputAdornment position="end">
                                <ToggleButtonGroup
                                    value={tipoTalla}
                                    exclusive
                                    onChange={(e, newTipo) => {
                                    if (newTipo !== null) {
                                        setTipoTalla(newTipo);
                                        setTallaInput("");
                                        setFieldValue("talla", "");
                                    }
                                    }}
                                    size="small"
                                    sx={{
                                    "& .MuiToggleButton-root": {
                                        color: "rgba(255,255,255,0.6)",
                                        borderColor: "rgba(255,255,255,0.2)",

                                        fontSize: "14px",
                                        padding: "8px 18px",
                                        height: "40px",
                                        minWidth: "70px",

                                        fontWeight: "bold",
                                    },

                                    "& .Mui-selected": {
                                        backgroundColor: "rgb(62, 67, 150) !important",
                                        color: "white!important",
                                    },
                                    }}
                                >
                                    <ToggleButton value="letra">ABC</ToggleButton>
                                    <ToggleButton value="numero">123</ToggleButton>
                                </ToggleButtonGroup>
                                </InputAdornment>
                            ),
                            }}
                        />

                        {/* Dropdown de tallas */}
                        {showTallaOpciones && tallasFiltradas.length > 0 && (
                            <Box
                            sx={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                zIndex: 9999,
                                backgroundColor: "rgb(30,30,30)",
                                border: "1px solid rgba(255,255,255,0.15)",
                                borderRadius: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                            }}
                            >
                            {tallasFiltradas.map((talla, index) => (
                                <Box
                                key={index}
                                onMouseDown={() => {
                                    setTallaInput(talla);
                                    setFieldValue("talla", talla);
                                    setShowTallaOpciones(false);
                                }}
                                sx={{
                                    padding: "10px 16px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    "&:hover": {
                                    backgroundColor: "rgba(206, 220, 0, 0.15)",
                                    },
                                }}
                                >
                                {talla}
                                </Box>
                            ))}
                            </Box>
                        )}
                        </Box>
                    </Box>

                    {/* ===================== */}
                    {/* INPUT EMPRESA         */}
                    {/* Abre modal al hacer   */}
                    {/* click                 */}
                    {/* ===================== */}
                    <TextField
                        variant="filled"
                        label="Empresa"
                        name="cod_empresa"
                        value={empresaSeleccionada ? empresaSeleccionada.nombre : ""}
                        onClick={() => setOpenModalEmpresas(true)}
                        onChange={() => {}}
                        error={!!touched.cod_empresa && !!errors.cod_empresa}
                        helperText={
                        touched.cod_empresa && errors.cod_empresa
                            ? errors.cod_empresa
                            : "Haz clic para buscar empresa"
                        }
                        InputProps={{ readOnly: true }}
                        sx={{
                        gridColumn: "span 2",
                        cursor: "pointer",
                        "& input": { cursor: "pointer" },
                        }}
                    />

                    {/* ===================== */}
                    {/* INPUT IMAGEN          */}
                    {/* ===================== */}
                    <Box sx={{ gridColumn: "span 2" }}>
                        <Typography fontSize="14px" mb="5px">
                        Imagen del uniforme
                        </Typography>

                        <input
                        key={fileInputKey}
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (!file) return;
                            handleFileUpload(file, setFieldValue);
                        }}
                        />

                        {/* Preview de la imagen */}
                        {imagenPreview && (
                        <Box mt="10px">
                            <img
                            src={imagenPreview}
                            alt="Preview uniforme"
                            style={{
                                maxWidth: "150px",
                                maxHeight: "150px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                border: "1px solid rgba(255,255,255,0.2)",
                            }}
                            />
                        </Box>
                        )}

                        {touched.img && errors.img && (
                        <Typography color="error" fontSize="12px" mt="4px">
                            {errors.img}
                        </Typography>
                        )}
                    </Box>
                    </Box>

                    {/* ===================== */}
                    {/* Efecto para setear    */}
                    {/* cod_empresa en Formik */}
                    {/* cuando se selecciona  */}
                    {/* del modal             */}
                    {/* ===================== */}
                    {/* 
                    NOTA: Como setFieldValue no está disponible fuera del Formik render,
                    usar este useEffect dentro del componente padre para sincronizar
                    empresaSeleccionada con Formik via un ref o manejar el setFieldValue
                    pasándolo al modal directamente. Ver la nota al pie del documento.
                    */}

                    {/* BOTON */}
                    <Box display="flex" justifyContent="end" mt="20px">
                    <Button
                        type="submit"
                        sx={{
                        backgroundColor: "rgb(206, 220, 0)",
                        border: "none",
                        color: "black",
                        height: "7vh",
                        width: "10vw",
                        fontSize: "18px",
                        fontWeight: "bold",
                        borderRadius: "20px",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#bac609" },
                        }}
                        variant="contained"
                    >
                        Registrar Uniforme
                    </Button>
                    </Box>
                </form>
                )}
            </Formik>
        </Box>
    );
};      

const  checkoutSchema = yup.object().shape({
    descripcion: yup.string().required("La descripción es requerida"),
    talla: yup.string().required("La talla es requerida"),
    img: yup.string().required("Debe subir una imagen"),
    cod_empresa: yup
    .number()
    .required("Debe seleccionar una empresa")
    .min(1, "Empresa inválida"),
});

export default RegistroUniforme;
